import React, { useState } from 'react';
import Logo from '../ui/icons/Logo';
import ResetPasswordContainer from '../ui/containers/ResetPasswordContainer';
import ResetPasswordFormContainer from '../ui/containers/ResetPasswordFormContainer';
import { PremiumInput } from 'modules/emergencies/components/ui/inputs/customInput';
import { object, string } from 'yup';
import ResetPasswordButton from '../ui/buttons/ResetPasswordButton';
import ErrorText from '../ui/text/ErrorText';
import * as http from 'utils/http';
import config from 'config';
import Title from '../ui/text/Title';
import Label from '../ui/text/Label';
import { LoginIcon } from 'assets/icons/icon_by_config/LoginIcon';

const emailSchema = object({ email: string().email() });

const PasswordResetEmail = ({ t }) => {
  const [email, setEmail] = useState('');
  const [hasError, setHasError] = useState(false);
  const [success, setSuccess] = useState();
  const [successError, setSuccessError] = useState('');

  const handleClick = async () => {
    const isValidEmail = await emailSchema.isValid({ email });
    setHasError(!isValidEmail);
    if (isValidEmail) {
      try {
        await http.rawPost(`${config.BASE_URL}/v1/request_reset_pwd/`, { credential: email });
        setSuccess(true);
      } catch (error) {
        setSuccessError(`${t.success_error} ${email}`);
        setSuccess(false);
      }
    }
  };
  return (
    <ResetPasswordContainer>
      <Logo alt="logo" src={LoginIcon()} />
      <Title>{t.title}</Title>
      {success ? (
        <Label>
          {t.success}
          <b>{email}</b>
        </Label>
      ) : (
        <ResetPasswordFormContainer>
          <Label>{t.label}</Label>
          <PremiumInput
            width={'100%'}
            type="text"
            label={'E-mail'}
            value={email}
            isRequired={true}
            hasError={hasError}
            onChange={(e) => {
              setEmail(e.target.value);
              setHasError(false);
            }}
          />
          {hasError && <ErrorText>{t.error}</ErrorText>}
          {success === false && <ErrorText>{successError}</ErrorText>}
          <ResetPasswordButton
            onClick={handleClick}
            size="L"
            fullWidth
            text={t.button}
            disabled={email === ''}
          />
        </ResetPasswordFormContainer>
      )}
    </ResetPasswordContainer>
  );
};

export default PasswordResetEmail;
